import axios from '../../../core/services/axios';

/* eslint-disable import/prefer-default-export */

export const getOrganizations = (params) => axios.get('/api/organizations', {
  params,
});
